// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ink"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 19.9996H21V13.0025L19 10.0039H5L3 13.0025V19.9996Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.2002 4V10.0043H16.8002V4H7.2002Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.2002 4V10.0043H16.8002V4H7.2002Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 19.9996H21V13.0025L19 10.0039H5L3 13.0025V19.9996Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const InkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ink',
    ref,
    icon: element,
  },
));

InkIcon.displayName = 'InkIcon';

export default InkIcon;
